<div fxLayout="column" fxLayoutGap="10px">
	<h1 mat-dialog-title style="text-align: center;">Upload Document</h1>
	<div class="dndzone" (click)="disableUpload ? false : null">
		<input type="file" #fileDrpRef id="fileDrpRef" multiple (change)="fileBrowseHandler($event.target.files)" />
		<h3>Browse / Drag and Drop your files here</h3>
		<label for="fileDrpRef">Only 10 documents can be uploaded per batch upload.</label>
	</div>
	<div style="width: 100%;" *ngIf="isUploading$ | async;">
		<mat-progress-bar mode="indeterminate"></mat-progress-bar>
	</div>
	<div class="file-list" [formGroup]="form" *ngIf="documents.length > 0">
		<table style="width: 100%;">
			<thead>
				<tr class="header">
				<th class="title-col">File Name</th>
				<th class="title-col">Title</th>
				<th>Hide from customers</th>
				<th>Hide from field workers</th>
				<th>Include in invoicing</th>
				<th></th>
			</tr>
			</thead>
			<tbody>
				<ng-container formArrayName="documents">
					<ng-container *ngFor="let document of documents.controls;
				            let i = index">
						<tr [formGroupName]="i">
							<td class="title-col">
								<div style="width: 100%;">{{document.value.fileName}}
									<p class="error">{{document.value.error}}</p>
									<p [ngClass]="getStatusClass(document)">{{document.value.uploadStatus}}</p>
								</div>
							</td>
							<td>
								<mat-form-field floatLabel='never' style="width: 100%;">
									<input matInput type="text" placeholder="Title" formControlName="title" maxlength="100"/>
									<mat-error>Required </mat-error>
								</mat-form-field>
							</td>
							<td class="checkbox-col">
								<mat-checkbox formControlName="hideFromCustomer" (change)="hideFromCustomerOnChange(document)"></mat-checkbox>
							</td>
							<td class="checkbox-col">
								<mat-checkbox formControlName="hideFromFieldWorker"></mat-checkbox>
							</td>
							<td class="checkbox-col">
								<div matTooltip="Documents hidden from customers cannot be included in invoicing.">
									<mat-checkbox formControlName="includeInInvoicing"></mat-checkbox>
								</div>
							</td>
							<td>
								<button type="button" mat-icon-button color="warn" (click)="documents.controls.splice(i, 1)" [disabled]="isFinished || (isUploading$ | async)">
									<mat-icon>delete</mat-icon>
								</button>
							</td>
						</tr>
					</ng-container>
				</ng-container>
				
			</tbody>
		</table>
	</div>
	<div mat-dialog-actions>
		<button mat-button mat-dialog-close color="warn" [disabled]="isFinished || (isUploading$ | async)">
			Cancel
		</button>
		<button mat-button [disabled]="form.invalid" color="primary" [mat-dialog-close]="form" *ngIf="isFinished">
			Close
		</button>
		<button mat-button [disabled]="form.invalid" color="primary" (click)="uploadDocument()" *ngIf="!isFinished" [disabled]="(isUploading$ | async)">
			Save
		</button>
		<span *ngIf="isFinished" class="upload-success">Process upload finished.</span>
	</div>
</div>